import hash from 'js-sha512'

import { normalizeInvite } from '../utils/normalize'
import Exception from '../utils/exception'

class DispatcherService {
  
  static getInviteId () {
    const urlParams = new URLSearchParams(window.location.search)
    const inviteId = urlParams.get('inviteId') || undefined
    return inviteId
  }

  static getInviteKey () {
    const urlParams = new URLSearchParams(window.location.search)
    const inviteKey = urlParams.get('inviteKey') || undefined
    return inviteKey
  }

  static isCountdownEnabled () {
    const urlParams = new URLSearchParams(window.location.search)
    const countdown = urlParams.get('countdown') || false
    return (countdown === 'true')
  }

  static getPhotoScore () {
    const urlParams = new URLSearchParams(window.location.search)
    const photoScore = urlParams.get('photoScore') || undefined
    return photoScore
  }

  static getFaceBoxHeight () {
    const urlParams = new URLSearchParams(window.location.search)
    const faceBoxHeight = urlParams.get('boxHeight') || undefined
    return faceBoxHeight
  }

  static getFaceBoxWidth () {
    const urlParams = new URLSearchParams(window.location.search)
    const faceBoxWidth = urlParams.get('boxWidth') || undefined
    return faceBoxWidth
  }

  static async loadInviteLogo (inviteId, imageId) {
    const res = await window.fetch(`/selfregister/v1/invites/${inviteId}/images/${imageId}/media`)
    if (res.status !== 200) {
      throw new Error('Falhou ao carregar imagem')
    }
    const blob = await res.blob()
    return window.URL.createObjectURL(blob)
  }
  
  static async loadInvite () {
    const inviteId = DispatcherService.getInviteId()
    const res = await window.fetch(`/selfregister/v1/invites/${inviteId}/flow`)
    if (res.status !== 200) {
      throw new Exception(res.status, 'Requisição falhou')
    }
    const data = await res.json()

    console.log('Flows', data)
    const invite = normalizeInvite(data)
    invite.theme.logoUrl = await DispatcherService.loadInviteLogo(inviteId, invite.theme.logo)

    return invite
    //return normalizeInvite(require('../assets/samples/invite.js'))
  }

  static async reserve (value) {
    const inviteId = DispatcherService.getInviteId()
    const body = value ? JSON.stringify(value) : undefined
    const res = await window.fetch(`/selfregister/v1/invites/${inviteId}/reserve`, { 
      method: 'POST', 
      headers: { "Content-Type": "application/json" },
      body
    })
    if (res.status !== 200) {
      throw { status: res.status }
    }
    const { reserveId } = await res.json()
    return reserveId
    //return Math.floor(Math.random()*32768)
  }

  static async loadPublicDocument (documentId) {
    const res = await window.fetch(`/selfregister/v1/documents/public/${documentId}`, { 
      headers: { "Content-Type": "application/json" }
    })
    if (res.status !== 200) {
      throw new Error('Requisição falhou')
    }
    const document = await res.json()
    return document
    //return require('../assets/samples/publicDocument.js')
  }

  static async loadDocument (documentId) {
    const inviteId = DispatcherService.getInviteId()
    const res = await window.fetch(`/selfregister/v1/invites/${inviteId}/documents/${documentId}`, { 
      headers: { "Content-Type": "application/json" }
    })
    if (res.status !== 200) {
      throw new Error('Requisição falhou')
    }
    const document = await res.json()
    return document
    //return require('../assets/samples/document.js')
  }

  static async finalize ({ photo, ...data }) {
    const res = await window.fetch(`/selfregister/v1/guests`, { 
      method: 'POST', 
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify(data)
    })
    if (res.status !== 201) {
      throw { status: res.status }
    }

    const guestInfo = await res.json()
    if (photo) {
        const res = await fetch(`/selfregister/v1/guests/${guestInfo.id}/media`, {
            method: 'POST',
            body: photo,
            headers: { "Content-Type": "image/png" },
        })
      
        if (res.status !== 200) {
            throw new Error('Falhou ao realizar o upload da foto')
        }
    } else {
        const res = await fetch(`/selfregister/v1/guests/${guestInfo.id}/nomedia`, {
            method: 'GET'
        })
        
        if (res.status !== 200) {
            throw new Error('Falhou ao chamar o /nomedia endpoint')
        }
        console.warn('Foto nao foi enviada pois não teve foto tirada neste processo por algum motivo.');
    }
    return guestInfo
  }

  static getReqId () {
    const urlParams = new URLSearchParams(window.location.search)
    const reqId = urlParams.get('reqId') || undefined
    return reqId
  }

  static getEmailFromURL () {
    const urlParams = new URLSearchParams(window.location.search)
    const email = urlParams.get('email') || undefined
    return email
  }

  static async getManagerConfig () {
    const headers = { 'Content-Type': 'application/json' }
    const res = await fetch('/manager/v1/configs', { method: 'GET', headers })
    if (res.status !== 200) {
        throw new Exception(res.status, `Ocorreu um erro: GET /manager/v1/configs`)
    }
    const config = await res.json()
    return config
  }

  static async confirmSignup (name, password) {
    const reqId = DispatcherService.getReqId()
    const inviteId = DispatcherService.getInviteId()
    const email = DispatcherService.getEmailFromURL()

    const body = { 
      reqId, inviteId, name, 
      password: hash.sha512(email + password)
    }

    const res = await fetch(`/manager/v1/user/signup/confirm`, {
      method: 'POST',
      body: JSON.stringify(body), 
      headers: { "Content-Type": "application/json" }
    })

    if (res.status !== 200) {
      throw new Error(`Falhou ao completar o cadastro (status code: ${res.status})`)
    }
  }

  static shouldReload () {
    const urlParams = new URLSearchParams(window.location.search)
    const reload = urlParams.get('reload') || undefined
    return reload === 'true' || reload === true
  }

  static getReloadTimeout () {
    const urlParams = new URLSearchParams(window.location.search)
    const reloadTimeout = urlParams.get('reloadTimeout') || undefined
    return reloadTimeout && parseInt(reloadTimeout) ? parseInt(reloadTimeout) : 5000
  }
}


export default DispatcherService